import type { SelectOption } from "core/entities";
import { useClerks } from "./useClerks";

export function useClerkSelectOptions() {
  const { data, isLoading, isError } = useClerks();

  const clerkSelectOptions: SelectOption[] =
    data?.items
      ?.sort((a: any, b: any) => (a.name > b.name ? 1 : -1))
      .map(({ name, surname, id, userName }) => ({
        label: name && surname ? `${name} ${surname}` : userName,
        value: id,
      }))
      .filter((input): input is { label: string; value: string } =>
        Boolean(input.label && input.value)
      ) || [];

  return { options: clerkSelectOptions, data, isLoading, isError };
}
